import Vue from "vue";

export default {
    namespaced: true,
    state: {
        stage: null,
        comment: null,
        recommendation: null,
        data: null,
        loading: false,
        devices: {},
        conclusion: null,
        activeDeviceTab: 'devices',
        thermograms: null
    },

    getters: {
        stage: state => state.stage,
        recommendation: state => state.recommendation,
        comment: state => state.comment,
        data: state => state.data,
        loading: state => state.loading,
        getDevices: state => state.devices,
        getComplexExercises: state => state.devices.available_complex_exercises,
        activeDeviceTab: state => state.activeDeviceTab,
        conclusion: state => state.conclusion,
        visitId: state => state.data.id,
    },

    mutations: {
        SET_STAGE: (state, stage) => {
            state.stage = stage
        },
        SET_COMMENT: (state, comment) => {
            state.comment = comment
        },
        SET_RECOMM: (state, recommendation) => {
            state.recommendation = recommendation
        },
        SET_DATA: (state, data = null) => {
            state.data = data
        },
        SET_DOCUMENTS: (state, data = null) => {
            state.documents = data
        },
        SET_LOADING: (state, data) => {
            state.loading = data
        },
        SET_DEVICES: (state, data) => {
            state.devices = data
        },
        SET_ACTIVE_TAB: (state, data) => {
            state.activeDeviceTab = data
        },
        SET_CONCLUSION: (state, data) => {
            state.conclusion = data
        },
        SET_THERMOGRAMS: (state, data) => {
            state.thermograms = data
        },
        ADD_MARKET_PRODUCT: (state, data) => {
            state.conclusion.market_products = state.conclusion.market_products.concat(data);
        },
        ADD_MARKET_PROCEDURE: (state, data) => {
            state.conclusion.procedures = state.conclusion.procedures.concat(data);
        },
    },

    actions: {
        SET_STAGE: function ({commit}, data) {
            commit('SET_STAGE', data);
        },
        SET_RECOMM: function ({commit}, data) {
            commit('SET_RECOMM', data);
        },
        SET_COMMENT: function ({commit}, data) {
            commit('SET_COMMENT', data);
        },
        LOAD_USER_DOCUMENTS: function ({getters, commit}) {

            this.$api.documents.getList(getters.data.user.id).then((response) => {
                // commit('SET_DOCUMENTS', response.data)
                commit('userDocuments/SET_DOCUMENTS', response.data, {root: true})

            }).catch((response) => {
                Vue.prototype.$notify.error({
                    title: "Ошибка загрузки списка документов 😕",
                    message: response.response.data.message,
                })
            })
        },
        SET_DATA: function ({commit}, data) {
            commit('SET_DATA', data);
        },
        SET_ACTIVE_TAB: function ({commit}, data) {
            commit('SET_ACTIVE_TAB', data);
        },

        CLEAR_CONCLUSION: function ({commit}) {
            commit('SET_CONCLUSION', {});
        },

        ADD_MARKET_PRODUCT: function ({commit}, data) {
            commit('ADD_MARKET_PRODUCT', data);
        },
        ADD_MARKET_PROCEDURE: function ({commit}, data) {
            commit('ADD_MARKET_PROCEDURE', data);
        },

        UPDATE_CONCLUSION: async function ({getters, commit}, payload) {
            let payData = {...payload}

            payData.market_products = payData.market_products.filter(bad => bad.selected)
            payData.market_products = payData.market_products.map(item => {
                return item.id
            })
            payData.procedures = payData.procedures.map(item => {
                return item.id
            })

            return new Promise((resolve, reject) => {
                this.$api.visit.updateConclusion(getters.visitId, payData).then((response) => {
                    commit('SET_CONCLUSION', response.data);
                    resolve()
                }).catch((response) => {
                    reject(response)
                })
            })
        },
        GENERATE_CONCLUSION: async function ({commit}, payload) {

            commit('SET_LOADING', true)

            return new Promise((resolve, reject) => {

                this.$api.visit.generateConclusion(payload.visitId, payload.data).then((response) => {
                    commit('SET_CONCLUSION', response.data);
                    resolve()
                }).catch((response) => {
                    reject(response)
                }).finally(() => {
                    commit('SET_LOADING', false)

                })
            })
        },

        LOAD_VISIT_DATA: async function ({commit, dispatch, getters}, payload) {
            commit('SET_LOADING', true)

            await this.$api.visit
                .device(payload.visitId)
                .then((response) => {
                    let dataS = {}
                    response.data.results.forEach((item) => {
                        dataS[item.diagnostic_field_id] = {}
                        dataS[item.diagnostic_field_id].value = item
                    })
                    //////
                    response.data.devices.forEach((item, index) => {
                        item.diagnostic_field.forEach((field, indexField) => {
                            if (dataS[field.id]) {
                                let deviceField =
                                    response.data.devices[index].diagnostic_field[indexField]
                                response.data.devices[index].diagnostic_field[
                                    indexField
                                    ] = Object.assign(deviceField, dataS[field.id])
                            }
                        })
                    })
                    commit('SET_DEVICES', response.data);

                    let filesId = []
                    response.data.results.forEach(item => {
                        const files = item.file || []
                        files.forEach(file => {
                            let fileExt = file.ext || ''
                            fileExt = fileExt.toLowerCase()
                            if (fileExt !== 'bin' && fileExt !== 'dtv') return
                            filesId.push(file.id)
                        })
                    })

                    if (payload.neural) {
                        dispatch('thermogram/LOAD_THERMOGRAMS', filesId, {root: true})
                        dispatch('thermogram/LOAD_NEURAL_DATA', getters.visitId, {root: true})
                    }
                })
                .catch((response) => {
                    Vue.prototype.$notify.error({
                        title: "Ошибка загрузки списка 😕",
                        message: response.response.data.message,
                    })
                    Vue.prototype.$router.push({name: "visit.list"})
                })
                .finally(() => {
                    commit('SET_LOADING', false)
                })
        }
    },
};
